import { Component, Inject, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-whatsnew',
    templateUrl: './whatsnew.component.html',
    styleUrls: ['./whatsnew.component.scss'],
    standalone: false
})
export class WhatsnewComponent {
    constructor(private dialogRef: MatDialogRef<WhatsnewComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    confirmWhatsNew(event) {
        this.dialogRef.close(true);
    }

    close() {
        this.dialogRef.close(false);
    }
}
